import styled, { css } from "styled-components/macro";
import { motion } from "framer-motion";
import { rgba } from "polished";

import {
  space,
  borderRadius,
  fontSize,
  fontStyle,
} from "shared/styles/constants";
import { getStatus, defaultLink } from "shared/styles/defaults";
import { IStatus } from "shared/types";
import { Spacer } from "shared/layout";
import { Icon } from "shared/styles";

export interface StyledMessageProps {
  status?: IStatus;
  hideBackground?: boolean;
  justifyContent?: "center";
}

export const StyledMessage = styled(motion.div)<StyledMessageProps>`
  display: flex;
  align-items: "flex-start";

  justify-content: ${({ justifyContent = "flex-start" }) => justifyContent};

  ${({ hideBackground }) =>
    !hideBackground &&
    css`
      padding: ${space.s} ${space.m};
    `};
  border-radius: ${borderRadius.m};

  background-color: ${({ hideBackground, status }) =>
    hideBackground ? "none" : rgba(getStatus(status).bgColor, 0.25)};

  ${fontStyle.medium}
  color: ${({ status }) => getStatus(status).textColor};

  @media print {
    border-radius: 0;
  }
`;

export const StyledContent = styled(Spacer)`
  word-break: break-word;

  &,
  p {
    line-height: 1.5;
  }

  > * {
    max-width: 100%;
  }
`;

export const StyledIcon = styled(Icon)`
  margin: 2px 0;
`;

export const StyledDismissContainer = styled.div`
  margin-left: auto;
`;

export const StyledDismissButton = styled.button`
  ${defaultLink()}

  margin-left: auto;
  margin-left: ${space.xs};

  ${fontSize.xs};
`;
